<template>
  <div class="audit-status">
    <h3>北京老科技工作者总会会员管理系统</h3>
    <img src="../../assets/img/auditState.png" alt="" class="status-img">
  </div>
</template>

<script>
  export default {
    name: "AuditStatus"
  }
</script>

<style scoped lang="scss">
.audit-status{
  width: 1200px;
  margin: 0 auto;
  h3{
    padding-top: 50px;
    font-size: 26px;
    line-height: 52px;
    color: #ffffff;
  }
  .status-img{
    display: block;
    margin: 100px auto;
  }
}
</style>
